import { Dialog, DialogActions, DialogContent, DialogTitle, Theme, useMediaQuery } from "@mui/material"
import DialogTitleClose from "../../../components/Misc/Dialog/Components/DialogTitleClose"
import AdjudicationOverview from "./AdjudicationOverview"
import { AdjudicationSolvedOperation, AdjudicationPendingOperation, SolveAdjudicationCaseAttack, SolveAdjudicationCaseDecision } from "neurotec-megamatcherid-management-client-adjudicator"
import { APIsContext } from "../../../Store/APIs/context"
import { useContext, useState } from "react"
import { useSnackbar } from "notistack"
import ConfirmationButton from "../../../components/Misc/Dialog/ConfirmationButton"
import DeleteIcon from '@mui/icons-material/Delete';
import AdjudicationActionButtons from "./AdjudicationActionButtons"
import ButtonLightGray from "../../../components/Filter/Components/ButtonLightGray"
import { AdjudicationAdjudicatorDecision } from "neurotec-megamatcherid-management-client"
import AdjudicationDecisionOverview from "./AdjudicatorDecisionOverview"

interface IAdjudicationOverviewDialogProps {
    decisions?: boolean
    onDelete?: () => void
    disableAction?: boolean
    open: boolean
    onClose: () => void
    adjudication: AdjudicationPendingOperation | AdjudicationSolvedOperation
    reload?: () => void
}

const AdjudicationOverviewDialog: React.FC<IAdjudicationOverviewDialogProps> = (props) => {

    const { enqueueSnackbar } = useSnackbar();
    const apiState = useContext(APIsContext).state
    const isSmall = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));
    const [decisions, setDecisions] = useState<AdjudicationAdjudicatorDecision[]>([])
    const [openDecisions, setOpenDecisions] = useState(false)
    
    const handleExited = () => {}

    const handleSolve = (decision: SolveAdjudicationCaseDecision, attack: SolveAdjudicationCaseAttack) => {
        apiState.AdjudicationApi.solveAdjudicationCase({
            uuid: (props.adjudication as AdjudicationPendingOperation)?.adjudicationPending?.uuid,
            decision: decision,
            attack: attack === "UNRECOGNIZED"? "UNRECOGNIZED" : attack
        }).then(res => {
            props.onClose()
            props.reload?.()
        }).catch(e => {
            enqueueSnackbar(e.message, {variant: "error"})
        })
    }

    const handleGetDecisions = () => {
        if (openDecisions) {
            setOpenDecisions(false)
        } else {
            const uuid = (props.adjudication as AdjudicationSolvedOperation)?.adjudicationSolved?.uuid ??
                         (props.adjudication as AdjudicationPendingOperation)?.adjudicationPending?.uuid
            if (uuid) {
                apiState.AdjudicationApi.getAdjudicationAdjudicatorDecisions({uuid: uuid}).then(res => {
                    setDecisions(res.data)
                    setOpenDecisions(true)
                }).catch(e => {
                    enqueueSnackbar(e.message, {variant: "error"})
                    setOpenDecisions(false)
                })
            }
        }
    }
    
    const getDecisionButton = (render: boolean) => (
        props.decisions && render?
        <ButtonLightGray onClick={handleGetDecisions} style={{height: "100%"}}>
            {openDecisions? "Overview" : "Decisions"}
        </ButtonLightGray> : undefined
    )

    return (
        <Dialog
            maxWidth="md"
            scroll="body"
            fullWidth
            fullScreen={isSmall ? true : false} 
            open={props.open}
            onClose={props.onClose}
            onTransitionExited={handleExited}
            PaperProps={{sx: {margin: "0rem"}}}
        >
            <DialogTitle>
                <DialogTitleClose
                    title={"Adjudication overview"}
                    onClose={props.onClose}
                />
            </DialogTitle>
            <DialogContent style={{paddingBottom: "0"}}>
                {openDecisions?
                    <AdjudicationDecisionOverview
                        decisions={decisions}
                    /> :
                    <AdjudicationOverview
                        disableAction={props.disableAction}
                        handleSolve={handleSolve}
                        adjudication={props.adjudication}
                    />
                }
            </DialogContent>
            <DialogActions>
                {getDecisionButton("adjudicationSolved" in props.adjudication)}
                {props.onDelete && (
                    <ConfirmationButton
                        icon={<DeleteIcon />}
                        buttonTitle="Delete"
                        title="Confirmation"
                        text="Are you sure you want to delete selected solved adjudication case? All solved adjudication case information will be removed and this action cannot be undone."
                        cancelText="Cancel"
                        confirmText="Delete"
                        confirm={() => props.onDelete?.()}
                        confirmColor='error'
                    />
                )}
                {!props.disableAction && (<AdjudicationActionButtons extraButton={getDecisionButton("adjudicationPending" in props.adjudication)} handleSolve={handleSolve}/>)}
            </DialogActions>
        </Dialog>
    )
}

export default AdjudicationOverviewDialog